import * as React from "react";
import parse, { domToReact as domToReact$1 } from "html-react-parser";
import { Element } from "html-react-parser";
import DOMPurify from "isomorphic-dompurify";
const parseHtml = (html, options, onClick) => {
  const sanitized = DOMPurify.sanitize(html, {
    FORBID_TAGS: ["script", "style"],
    ADD_ATTR: ["target"]
  });
  return parse(sanitized, {
    ...options,
    replace: (node, index) => {
      if (options?.replace) {
        const result = options.replace(node, index);
        if (result !== node) {
          return result;
        }
      }
      const handleKeyDown = (e) => {
        if (!onClick) {
          return;
        }
        if (e.key !== "Enter" && e.key !== " ") {
          return;
        }
        if (e.key === " ") {
          e.preventDefault();
        }
        onClick();
      };
      if (node.type === "tag" && node.name === "a" && node.attribs?.href && onClick) {
        return /* @__PURE__ */ React.createElement("a", { ...node.attribs, onClick, onKeyDown: handleKeyDown, role: "link", tabIndex: 0 }, domToReact$1(node.children));
      }
      return node;
    }
  });
};
const domToReact = (nodes) => domToReact$1(nodes);
export {
  Element,
  domToReact,
  parseHtml
};
//# sourceMappingURL=parse-html.js.map
